export const isKeyframesTarget = (v) => {
    return Array.isArray(v);
};
//# sourceMappingURL=is-keyframes-target.js.map